import i18next from 'i18next';

/** Функция для получения перевода там, где нет возможности использовать ``useTranslation``
 *
 * @param namespace - раздел перевода
 *
 * @returns функцию, принимающую ключ и возврашающую перевод
 */
export const getTranslated = (namespace: string) => (key: string) =>
	i18next.t(key, { ns: namespace });
